import React from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'
import SetKitDisplay from '../../SetKitDisplay'
import { 
  Container,
  FlexBox,
  ImageWrapper,
  TextWrapper,
  Quantity,
  LightText,
  ItemTotal
} from "./style/ReturnDetailsItemInfoWMO.css"

export default function ReturnDetailsItemInfoWMO({ orderDetails, isDesktop }) {
  const { item } = orderDetails
  let vehicleInfo = ''

  if (item.vehicle) {
    const {
      year,
      make,
      model,
      submodel,
      engine,
    } = item.vehicle
    if (year && make && model) {
      vehicleInfo = `${year} ${make} ${model}`
      vehicleInfo += submodel ? `&nbsp; ${submodel}` : ''
      vehicleInfo += engine ? `&nbsp; ${engine}` : ''
    }
  }

  const {
    title,
    image,
    brand,
    quantity,
    shipping,
    sku,
    price,
    warranty,
    core,
    parentItem
  } = item

  const parentSku = parentItem ? {
    sku_title: parentItem.title,
    ImageURL: parentItem.image.url,
    sku: parentItem.sku,
    list_price: parentItem.price.list,
  } : null

  const defaultImage = 'https://cld.partsimg.com/image/upload/d_noimage.jpg'
  const imageSize = isDesktop ? '108px' : '96px'
  const corePrice = core && core.price ? core.price : 0
  const warrantyPrice = warranty && warranty.price ? warranty.price : 0
  const subTotal = price.list + warrantyPrice + corePrice
  
  let imageUrl = `${defaultImage}/images/${sku.toLowerCase()}_1.jpg`
  if (image) {
    imageUrl = image.url
  }

  return (
    <Container>
      <Box>
        <FlexBox>
          <ImageWrapper>
            <ImageLoader
              fit="contain"
              alt={title || null}
              src={imageUrl}
              width={imageSize}
              height={imageSize}
              cloudinaryParams="w_100,h_100"
            />
            <Quantity>
              <p>QTY:&nbsp;{ quantity.return }</p>
            </Quantity>
          </ImageWrapper>
          <Box>
            {
              vehicleInfo && (
                <Text
                  color="dark-1"
                  dangerouslySetInnerHTML={
                    {
                      __html: `
                        FOR&nbsp;
                        ${vehicleInfo}
                      `,
                    }
                  }
                  size="small"
                  style={{ lineHeight: '24px' }}
                />
              )
            }
            <TextWrapper>
              <Text>
                { brand ? brand.name : null }
                &reg;
              </Text>
              {" "}
              <Text
                dangerouslySetInnerHTML={
                  {
                    __html: title || null
                  }
                }
              />
            </TextWrapper>
            <LightText>
              Part Number: {sku}
            </LightText>
            { price && (
            <>
              <LightText>
                Unit Price:&nbsp;
                  $
                  { price.list ? price.list.toFixed(2) : null }
              </LightText>
              {
                corePrice > 0 && (
                  <LightText>
                    { core.label }
                    :&nbsp;
                      $
                      { core && core.price ? core.price.toFixed(2) : null }
                  </LightText>
                )
              }
              {
                warrantyPrice > 0 && (
                  <LightText>
                    { warranty.label }
                    :&nbsp;
                      $
                      { warranty && warranty.price ? warranty.price.toFixed(2) : null }
                  </LightText>
                )
              }
              {
                shipping && shipping.method && (
                  <LightText>
                    Shipping Method:&nbsp;
                    { shipping.method }
                  </LightText>
                )
              }
              <ItemTotal>
                Item Total:&nbsp;
                $
                { (subTotal * quantity.return).toFixed(2) }
              </ItemTotal>
            </>
            )}
            {
              parentSku && isDesktop && (
                <Box margin={{ top: '16px' }}>
                  <SetKitDisplay
                    parentSku={parentSku}
                    isWmoEnabled
                  />
                </Box>
              )
            }
          </Box>
        </FlexBox>
        {
          parentSku && !isDesktop &&  (
            <Box margin={{ top: '16px' }}>
              <SetKitDisplay
                parentSku={parentSku}
                isWmoEnabled
              />
            </Box>
          )
        }
      </Box>
    </Container>
  )
}
